import { Injectable } from '@angular/core';
import { Observable, defer, from, of } from 'rxjs';
import { catchError, startWith, switchMap } from 'rxjs/operators';
import { EscriptStatusRecord } from '../pharmacy-escript.descriptor';

/**
 * Status for vendors WITHOUT a webhook (EasyRx): a doctor-triggered fetch — once on subscribe
 * (modal open) and again on each `refresh$` emission (manual Refresh button). NO `timer`/interval.
 *
 * Built in Phase A and exercised by the exit-gate smoke descriptor; EasyRx (Phase B) reuses it
 * unchanged.
 */
@Injectable({ providedIn: 'root' })
export class OnDemandStatusSource {
  fetch$(
    fetchOnce: () => Promise<EscriptStatusRecord | null>,
    refresh$?: Observable<void>
  ): Observable<EscriptStatusRecord | null> {
    const trigger$ = refresh$ ? refresh$.pipe(startWith(undefined as void)) : of(undefined as void);
    // defer so each trigger re-invokes the promise; catchError keeps a rejected fetch from killing the stream
    return trigger$.pipe(switchMap(() => defer(() => from(fetchOnce())).pipe(catchError(() => of(null)))));
  }
}
